/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:28 GMT
 */
const tokens = {
    component: {
        table: {
            borderRadius: {
                value: "4px",
                type: "dimension",
            },
            borderWidth: {
                value: "1px",
                type: "dimension",
            },
            borderColor: {
                value: "#EBEEF2",
                type: "color",
            },
            row: {
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
                height: {
                    value: "48px",
                    type: "dimension",
                },
                zebraStripe: {
                    backgroundColor: {
                        value: "#F4F6F8",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#94949429",
                        type: "color",
                    },
                },
                selected: {
                    backgroundColor: {
                        value: "#94949452",
                        type: "color",
                    },
                },
            },
            compact: {
                row: {
                    height: {
                        value: "40px",
                        type: "dimension",
                    },
                },
                header: {
                    height: {
                        value: "40px",
                        type: "dimension",
                    },
                },
            },
            header: {
                paddingHorizontal: {
                    value: "16px",
                    type: "dimension",
                },
                backgroundColor: {
                    value: "#EBEEF2",
                    type: "color",
                },
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "fontWeight",
                },
                height: {
                    value: "52px",
                    type: "dimension",
                },
                first: {
                    paddingLeft: {
                        value: "32px",
                        type: "dimension",
                    },
                },
                last: {
                    paddingRight: {
                        value: "32px",
                        type: "dimension",
                    },
                },
                iconButton: {
                    color: {
                        value: "#949494",
                        type: "color",
                    },
                    active: {
                        color: {
                            value: "#1e1e1e",
                            type: "color",
                        },
                    },
                },
            },
            cell: {
                paddingHorizontal: {
                    value: "16px",
                    type: "dimension",
                },
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
                borderColor: {
                    value: "#D5E3F1",
                    type: "color",
                },
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
                first: {
                    paddingLeft: {
                        value: "32px",
                        type: "dimension",
                    },
                },
                last: {
                    paddingRight: {
                        value: "32px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
